<script setup lang="ts">
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<template>
  <div class="media-buying">
    <div
      :class="[
        'content-wrapper',
        { 'content-wrapper_free': route?.meta?.freeWrapper }
      ]"
    >
      <RouterView />
    </div>
  </div>
</template>

